module.exports = __webpack_public_path__ + "assets/myAis.8b94466133e22188eabeb7411fec1e0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myAis.jpg
// module id = 618
// module chunks = 0